import z from 'zod';

export const swedishRegistrationNumber = z
  .string()
  .length(6, 'swedishLengthError')
  .regex(/^[A-HJ-PR-UW-Z]{3}\d{2}[A-HJ-PR-UW-Z0-9]$/i, 'swedishValidationError');

export const norwegianRegistrationNumber = z
  .string()
  .length(7, 'norwegianLengthError')
  .regex(/^[A-HJ-NPR-Z][A-HJ-NPR-Z0]\d{5}$/i, 'norwegianValidationError');
